import React, { useState } from 'react';
import { Paper, Box, Typography, TextField, Button, CircularProgress } from '@mui/material';
import { Save } from '@mui/icons-material';
import { useAuth } from '../../contexts/AuthContext';
import apiClient from '../../config/axios';
import ModalConfirm from '../../components/ModalConfirm';
import ModalResult from '../../components/ModalResult';

const TeacherDetailsSalary = ({ teacher, onUpdate }) => {
  const { user } = useAuth();
  const isAdmin = user?.roles?.includes('admin');
  const [salary, setSalary] = useState(teacher?.salaryPerLesson?.toString() || '');
  const [loading, setLoading] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [resultOpen, setResultOpen] = useState(false);
  const [resultMessage, setResultMessage] = useState('');
  const [resultSeverity, setResultSeverity] = useState('success');

  const handleSave = () => {
    const salaryValue = salary.trim() === '' ? null : parseFloat(salary);

    if (salaryValue !== null && (isNaN(salaryValue) || salaryValue < 0)) {
      setResultMessage('Il valore deve essere un numero positivo');
      setResultSeverity('error');
      setResultOpen(true);
      return;
    }

    setConfirmOpen(true);
  };

  const handleConfirm = async () => {
    setConfirmOpen(false);
    setLoading(true);

    try {
      const salaryValue = salary.trim() === '' ? null : parseFloat(salary);

      await apiClient.patch(`/api/user/${teacher._id}/salary`, {
        salaryPerLesson: salaryValue,
      });

      setResultMessage('Rimborso aggiornato con successo');
      setResultSeverity('success');
      setResultOpen(true);
    } catch (err) {
      setResultMessage(err.response?.data?.message || 'Errore nel salvataggio del rimborso');
      setResultSeverity('error');
      setResultOpen(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant='h6' sx={{ mb: 2 }}>
        Rimborso per Lezione
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <TextField
          label='Rimborso per Lezione (€)'
          type='number'
          value={salary}
          onChange={(e) => setSalary(e.target.value)}
          disabled={!isAdmin}
          InputProps={{
            inputProps: { min: 0, step: 0.01 },
          }}
          helperText={isAdmin ? 'Inserisci il rimborso per lezione del docente' : 'Solo gli amministratori possono modificare questo valore'}
        />

        {isAdmin && (
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button variant='contained' startIcon={loading ? <CircularProgress size={20} /> : <Save />} onClick={handleSave} disabled={loading}>
              Salva
            </Button>
          </Box>
        )}
      </Box>

      <ModalConfirm open={confirmOpen} title='Conferma aggiornamento' message='Sei sicuro di voler aggiornare il rimborso per lezione?' onConfirm={handleConfirm} onCancel={() => setConfirmOpen(false)} />

      <ModalResult
        open={resultOpen}
        onClose={() => {
          setResultOpen(false);
          if (onUpdate) {
            onUpdate();
          }
        }}
        message={resultMessage}
        severity={resultSeverity}
        title={resultSeverity === 'success' ? 'Successo' : 'Errore'}
      />
    </Paper>
  );
};

export default TeacherDetailsSalary;
